'use strict';

module.exports = function KeychainError(message) {
  return null;
};
